"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmMessage = exports.SystemMessage = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = require("../components");

var _wrappers = require("../wrappers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Message = function Message(_ref) {
  var message = _ref.message,
      top = _ref.top,
      type = _ref.type,
      show = _ref.show,
      dismiss = _ref.dismiss,
      _ref$confirm = _ref.confirm,
      confirm = _ref$confirm === void 0 ? null : _ref$confirm;
  var theme = (0, _wrappers.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-white system-message rounded ".concat(show),
    style: {
      top: "".concat(top, "rem")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n          bg-opacity-25 ".concat(theme["bg".concat(type)], "\n          rounded px-6 py-2 text-large\n        ")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-4"
  }, message), /*#__PURE__*/_react["default"].createElement(_components.Button, {
    onClick: dismiss,
    buttonTheme: "buttonSmallPrimary"
  }, "dismiss"), !confirm ? null : /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-2"
  }, /*#__PURE__*/_react["default"].createElement(_components.Button, {
    onClick: confirm,
    buttonTheme: "buttonSmallSuccess"
  }, "confirm")))));
};

var SystemMessage = /*#__PURE__*/function (_React$Component) {
  _inherits(SystemMessage, _React$Component);

  var _super = _createSuper(SystemMessage);

  function SystemMessage() {
    var _this;

    _classCallCheck(this, SystemMessage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      show: "show"
    });

    _defineProperty(_assertThisInitialized(_this), "timeout", null);

    return _this;
  }

  _createClass(SystemMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.duration) {
        this.timeout = setTimeout(this.dismiss.bind(this), this.props.duration);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      this.props.dismissSystemMessage(this.props.id);
    }
  }, {
    key: "dismiss",
    value: function dismiss() {
      this.setState({
        show: "hide"
      });
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.props.dismissSystemMessage, 750, this.props.id);
      this.props.onDismiss();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react["default"].createElement(Message, _extends({}, this.props, this.state, {
        dismiss: function dismiss(e) {
          return _this2.dismiss(e);
        }
      }));
    }
  }]);

  return SystemMessage;
}(_react["default"].Component);

exports.SystemMessage = SystemMessage;

var ConfirmMessage = /*#__PURE__*/function (_SystemMessage) {
  _inherits(ConfirmMessage, _SystemMessage);

  var _super2 = _createSuper(ConfirmMessage);

  function ConfirmMessage() {
    _classCallCheck(this, ConfirmMessage);

    return _super2.apply(this, arguments);
  }

  _createClass(ConfirmMessage, [{
    key: "confirm",
    value: function confirm() {
      this.setState({
        show: "hide"
      });
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.props.dismissSystemMessage, 750, this.props.id);
      this.props.onConfirm();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react["default"].createElement(Message, _extends({}, this.props, this.state, {
        dismiss: function dismiss(e) {
          return _this3.dismiss(e);
        },
        confirm: function confirm(e) {
          return _this3.confirm(e);
        }
      }));
    }
  }]);

  return ConfirmMessage;
}(SystemMessage);

exports.ConfirmMessage = ConfirmMessage;